import Vue from "vue";
import VueRouter from "vue-router";
import Cookies from "js-cookie";

// Views
import PageClients from "@/views/PageClients";
import PageServices from "@/views/PageServices";
import PageRecos from "@/views/PageRecos";
import PageOrders from "@/views/PageOrders";
import PageTrades from "@/views/PageTrades";
import PagePositions from "@/views/PagePositions";
import PageSolvency from "@/views/PageSolvency";
import PageSolvencyAV from "@/views/PageSolvencyAV";
import PageSolvencyConsolidated from "@/views/PageSolvencyConsolidated";
import PageEEFF from "@/views/PageEEFF";
import PageSEAFI from "@/views/PageSEAFI";
import PageCAE from "@/views/PageCAE";
import PageIRE from "@/views/PageIRE";
import PageICI from "@/views/PageICI";
import PageOthers from "@/views/PageOthers";
import PageError from "@/views/PageError";
import Page404 from "@/views/Page404";
import Page500 from "@/views/Page500";

// Components
import LayoutAside from "@/components/Layout/LayoutAside";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: {
      name: "Customer Registration"
    }
  },
  {
    path: "/",
    name: "eaf",
    component: LayoutAside,
    redirect: {
      name: "Customer Registration"
    },
    children: [
      {
        path: "clients",
        name: "Customer Registration",
        component: PageClients,
        meta: { title: "Registro de Clientes" }
      },
      {
        path: "services",
        name: "Customer Registration",
        component: PageServices,
        meta: { title: "Registro de Servicios" }
      },
      {
        path: "recommendations",
        name: "Recommendation Registration",
        component: PageRecos,
        meta: { title: "Registro de Recomendaciones" }
      },
      {
        path: "orders",
        name: "Orders Registration",
        component: PageOrders,
        meta: { title: "Registro de Orders" }
      },
      {
        path: "trades",
        name: "Trades Registration",
        component: PageTrades,
        meta: { title: "Registro de Operaciones" }
      },
      {
        path: "positions",
        name: "Positions Registration",
        component: PagePositions,
        meta: { title: "Registro de Posiciones" }
      },
      {
        path: "solvency",
        name: "Solvency procedure",
        component: PageSolvency,
        meta: { title: "Trámite EFS (Solvencia)" }
      },
      {
        path: "solvencyav",
        name: "Solvency procedure",
        component: PageSolvencyAV,
        meta: { title: "Trámite EFS (Solvencia)" }
      },
      {
        path: "solvencyconsolidated",
        name: "Solvency procedure",
        component: PageSolvencyConsolidated,
        meta: { title: "Trámite EFS Consolidado (Solvencia)" }
      },
      {
        path: "eeff",
        name: "EEFF procedure",
        component: PageEEFF,
        meta: { title: "Trámite EFS (EEFF)" }
      },
      {
        path: "seafi",
        name: "SEAFI procedure",
        component: PageSEAFI,
        meta: { title: "Trámite EFS (SEAFI)" }
      },
      {
        path: "ire",
        name: "IRE Procedure",
        component: PageIRE,
        meta: { title: "Trámite IRE" }
      },
      {
        path: "cae",
        name: "CAE Procedure",
        component: PageCAE,
        meta: { title: "Trámite CAE" }
      },
      {
        path: "ici",
        name: "ICI Procedure",
        component: PageICI,
        meta: { title: "Trámite ICI" }
      },
      {
        path: "others",
        name: "Others Procedure",
        component: PageOthers,
        meta: { title: "Otros Trámites" }
      }
    ]
  },
  {
    path: "/404",
    name: "404",
    component: Page404,
    props: true,
    meta: { title: "404" }
  },
  {
    path: "/500",
    name: "500",
    component: Page500,
    props: true,
    meta: { title: "500" }
  },
  {
    path: "/error",
    name: "error",
    component: PageError,
    props: true,
    meta: { title: "Error" }
  },
  {
    path: "*",
    redirect: {
      name: "Customer Registration"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

const isLogged = () => Cookies.get("token") !== undefined;

router.beforeEach((to, from, next) => {
  if (!isLogged()) {
    location.href = `${process.env.VUE_APP_WEB_ACCOUNT}/login/`;
  } else {
    next();
  }
});

const DEFAULT_TITLE = "EAF";
router.afterEach(to => {
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});

export default router;
